export const authModuleConfig = {
  loginPageRoute: 'auth/login',
};
